import { AsyncAction } from './AsyncAction';
import { AsyncScheduler } from './AsyncScheduler';
export var asyncScheduler = new AsyncScheduler(AsyncAction);
//# sourceMappingURL=async.js.map